// ============================================================
// ENGINE V2 — CONSTANTS
// ============================================================
// All tuneable values live here so they can be changed
// without touching engine logic.
// ============================================================

// ─── DIFFING ALGORITHM ───────────────────────────────────────

// Globally fixed damping factor. Controls how resistant existing
// trait scores are to change. Range: 0.01–0.99.
// Higher = more inertia (scores move slowly).
export const DAMPING = 0.99;

// Smoothing ratio for the quartile blend step.
// 3 = quartile (3:1 old-to-new weighting, ~25% movement per activity).
// Change to 2 for thirds (~33%), 4 for quintile (~20%).
export const SMOOTHING_RATIO = 3;

// Trait score scale
export const SCALE_MAX   = 100;
export const SCORE_FLOOR = 0;
export const SCORE_CEILING = 100;

// ─── GUARD CONSTRAINTS ───────────────────────────────────────

// Maximum career path nodes (any level) a student can have active
// at any given time. Configurable.
export const MAX_ACTIVE_NODES = 7;

// ─── SUGGESTION THRESHOLDS ───────────────────────────────────

// A node is a 'near-miss' if its overall distance is >= this value.
// Nodes further below (more negative) are excluded entirely.
export const NEAR_MISS_THRESHOLD = -20;

// Fraction of traits that must meet their minimum threshold for a
// node to be classified as 'positive' rather than 'near-miss'.
export const POSITIVE_MATCH_RATIO = 0.7; // 70%

// Maximum number of suggestions returned per engine run.
export const MAX_SUGGESTIONS = 10;
